export default __webpack_public_path__ + "static/media/connect-logo-x2.36cae50e.png";